import React from "react";
import styled from "styled-components";
import useCustomizerStore from "../../../state/customizer";
import closeBtn from "../../../assets/images/closeBtn.svg";
import { isMobile } from "react-device-detect";
import { motion, AnimatePresence, MotionConfig } from "framer-motion";
import Modal from "../../../util/Modal";

const MobileModalDisclaimer = () => {
  const { selectedDisclaimer, disclaimerOpen, setDisclaimerOpen } =
    useCustomizerStore();

  return (
    <MotionConfig transition={{ duration: 0.5 }}>
      <AnimatePresence>
        {isMobile && selectedDisclaimer.length > 0 && disclaimerOpen && (
          <Modal>
            <MobileDisclaimerContainer
              key="disclaimer-modal"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            >
              <div
                className="container"
                onClick={() => setDisclaimerOpen(false)}
              >
                <motion.div
                  className="disclaimer"
                  key="discalimer-container"
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 30 }}
                >
                  <div className="x" onClick={() => setDisclaimerOpen(false)}>
                    <img src={closeBtn} />
                  </div>
                  <p>{selectedDisclaimer}</p>
                </motion.div>
              </div>
            </MobileDisclaimerContainer>
          </Modal>
        )}
      </AnimatePresence>
    </MotionConfig>
  );
};

const MobileDisclaimerContainer = styled(motion.div)`
  background-color: #000;
  z-index: 998;

  .container {
    position: absolute;
    background-color: #000;
    width: 100vw;
    height: 100%;
    top: 60px;
    pointer-events: auto;
    color: "#fff";
    z-index: 998;

    .disclaimer {
      padding: 30px 40px;
      font-size: 12px;
      font-style: italic;
      background-color: #000;
      width: 100%;
      box-sizing: border-box;

      .x {
        position: absolute;
        z-index: 998;
        right: 15px;
        top: 15px;
        pointer-events: auto;
        cursor: pointer;

        img {
          width: 32px;
          height: 32px;
        }
      }
    }
  }
`;

export default MobileModalDisclaimer;
